import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
  ongoingKeyDetails,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promote';

export const affinityVariableEPlusOngoingContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Affinity Variable ePlus Ongoing']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
        electricity: ongoingKeyDetails,
        gas: ongoingKeyDetails,
        dual: ongoingKeyDetails,
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog(),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-affinity-variable-ePlus-ongoing/',
      },
    },
  },
};
